import { render, staticRenderFns } from "./Ratio.vue?vue&type=template&id=0e89069f&"
import script from "./Ratio.vue?vue&type=script&lang=ts&"
export * from "./Ratio.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports